import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import useSubmit from "../../hooks/useSubmit";
import {
  CircularProgress,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  styled,
} from "@mui/material";
import { motion } from "framer-motion";

import { useAlertContext } from "../../providers/AlertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const MySelect = styled(Select)({
  "& .MuiSelect-select": {
    color: "#f2f2f2", // Change the text color
    // Change the background color
  },
  "& .MuiSelect-icon": {
    color: "#f2f2f2", // Change the color of the arrow icon
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#f2f2f2", // Change the border color
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#f2f2f2", // Change the border color on hover
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#f2f2f2", // Change the border color when focused
  },
});

export default function FooterDesign() {
  const { isLoading, response, submit } = useSubmit();
  const { showAlert } = useAlertContext();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      type: "Freelance project proposal",
      comment: "",
    },
    onSubmit: (values) => {
      submit("https://john.com/contactme", values);
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .trim()
        .min(2, "Name is too short")
        .required("Name is Required"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      comment: Yup.string()
        .min(5, "Must be at least 5 characters")
        .required("Message is required"),
    }),
  });

  useEffect(() => {
    if (response) { 
      showAlert(response.type, response.message);
      if (response.type === "success") {
        formik.resetForm();
      }
    }
      
  }, [response,showAlert,formik]);

  return (
   
        <div className="col-lg-6 col-md-6 col-sm-12 form-column border-left">
          <form className="form-box" onSubmit={formik.handleSubmit}>
            {/* Name */}
            <div className="formGroup">
              <label htmlFor="name" className="uppercase">
                Your Name
              </label>
              <input id="name" name="name" {...formik.getFieldProps("name")} />

              <FormHelperText error>
                {formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : ""}
              </FormHelperText>
            </div>
            {/* Email */}
            <div className="formGroup">
              <label htmlFor="email" className="uppercase">
                Your E-mail
              </label>
              <input
                id="email"
                name="email"
                {...formik.getFieldProps("email")}
              />

              <FormHelperText error>
                {formik.touched.email && formik.errors.email
                  ? formik.errors.email
                  : ""}
              </FormHelperText>
            </div>

            {/* Type */}

            <div className="formGroup">
              <label htmlFor="type" className="uppercase mb-3">
                Choose one
              </label>
              <FormControl color="primary" fullWidth sx={{ color: "#f2f2f2" }}>
                <MySelect  id="type" name="type" {...formik.getFieldProps("type")}>
                  <MenuItem value="Freelance project proposal" selected>
                    Freelance project proposal
                  </MenuItem>
                  <MenuItem value="Open source consultancy session">
                    Open source consultancy session
                  </MenuItem>
                  <MenuItem value="Job proposal"> Job proposal</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </MySelect>
              </FormControl>
            </div>
            {/* Message */}
            <div className="formGroup">
              <label htmlFor="comment" className="uppercase">
                Your Text Message
              </label>
              <textarea
                placeholder="Express yourself freely. Your thoughts matter!"
                id="comment"
                name="comment"
                rows={window.innerWidth <= 1025 ? 2 : 1}
                {...formik.getFieldProps("comment")}
              />
              <FormHelperText error>
                {formik.touched.comment && formik.errors.comment
                  ? formik.errors.comment
                  : ""}
              </FormHelperText>
            </div>
            <motion.button
              disabled={isLoading}
              whileHover={{
                scale: 1.03,
                background:
                  "linear-gradient(45deg,  rgba(255,255,255,0.1) 0%,rgba(255,255,255,0.021) 50%)",
              }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 25 }}
              type="submit"
              className="form-button mt-5"
            >
              <span style={{ marginRight: "8px" }}>
                {isLoading && (
                  <CircularProgress size={24} thickness={6} color="inherit" />
                )}
              </span>
              {isLoading ? "Submitting..." : "Submit"}
              <FontAwesomeIcon icon={faArrowRight} />
            </motion.button>
          </form>
        </div>
  );
}
